
import {
  defineComponent,
  reactive,
  computed,
  ref,
  onMounted,
  onBeforeUnmount,
} from 'vue';
import { useStore } from 'vuex';
import BackgroundPattern from '@/components/BackgroundPattern.vue';
import HeroBackgroundCommon from '@/components/hero/HeroBackgroundCommon.vue';
import HeroBackgroundHeat from '@/components/hero/HeroBackgroundHeat.vue';
import HeroBackgroundEmobil from '@/components/hero/HeroBackgroundEmobil.vue';
import HeroBackgroundPhoto from '@/components/hero/HeroBackgroundPhoto.vue';
import HeroBackgroundBuilding from '@/components/hero/HeroBackgroundBuilding.vue';
import SectionSpacerClouds from '@/components/partials/SectionSpacerClouds.vue';

export default defineComponent({
  components: {
    HeroBackgroundCommon,
    HeroBackgroundHeat,
    HeroBackgroundEmobil,
    HeroBackgroundPhoto,
    HeroBackgroundBuilding,
    BackgroundPattern,
  },

  props: {
    hero: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const {
      ioappConfig: {
        themeUri,
        svg,
      },
    } = window;

    const store = useStore();
    store.dispatch('pages/setPageType', parseInt(props.hero, 10));

    const clouds = ref<InstanceType<typeof SectionSpacerClouds>>();
    const pattern = ref<InstanceType<typeof HTMLElement>>();
    const pageType = computed<string>(() => store.getters['pages/pageType']);

    const header = reactive({
      $el: null as null | HTMLElement,
    });

    const minHeight = reactive({ value: null as string | null });
    const minHeightPx = computed(() => (minHeight.value ? minHeight.value : null));
    const sloganSvg = computed(() => {
      if (pageType.value !== 'other') {
        const pt: string = pageType.value;
        return atob(svg.hero[pt]);
      }

      return null;
    });
    const hashtagSvg = computed(() => atob(svg.hero.hashtag));

    const setMinHeight = () => {
      const isPortrait = window.innerWidth < window.innerHeight;
      let $minHeight = 0;

      if (!isPortrait) {
        $minHeight = window.innerHeight;

        if (header.$el) {
          $minHeight -= header.$el.offsetHeight;
        }

        if (clouds.value && clouds.value.$el) {
          $minHeight -= clouds.value.$el.scrollHeight;
          $minHeight += window.innerWidth * 0.0515;
        }

        minHeight.value = `min-height:${$minHeight}px`;
      }
    };

    onMounted(() => {
      if (pageType.value === 'common') {
        header.$el = document.querySelector('header');
        window.addEventListener('resize', setMinHeight);
        window.addEventListener('load', setMinHeight);
        setMinHeight();
        for (let i = 100; i < 1000; i += 100) {
          setTimeout(setMinHeight, i);
        }
      } if (pattern.value) {
        pattern.value.style.backgroundImage = `url('${themeUri}/assets/img/hero-pattern.svg')`;
      }
    });

    onBeforeUnmount(() => {
      if (pageType.value === 'common') {
        window.removeEventListener('resize', setMinHeight);
        window.removeEventListener('load', setMinHeight);
      }
    });

    return {
      header,
      minHeightPx,
      pageType,
      clouds,
      pattern,
      sloganSvg,
      hashtagSvg,
    };
  },
});
